import api from './api';

/**
 * Fetch games with predictions for a specific sport and date
 */
export const getGamePredictions = async (sport, date) => {
  try {
    const params = new URLSearchParams();
    if (date) params.append('date', date);

    const response = await api.get(`/predictions/${sport}/games?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching game predictions:', error);
    throw error;
  }
};

/**
 * Fetch the sports currently in season.
 *
 * Backed by sports_seasons.is_active, so it is the single source of truth for
 * "is this sport playing right now". Anywhere that hardcodes a sport list will
 * drift the moment a season starts or ends -- the Parlay Workshop was still
 * offering NBA and NHL after both were set to off-season.
 */
export const getActiveSports = async () => {
  try {
    const response = await api.get('/predictions/active-sports');
    return response.data?.sports || [];
  } catch (error) {
    console.error('Error fetching active sports:', error);
    throw error;
  }
};

/**
 * Fetch all games across sports for a specific date
 */
export const getAllGamePredictions = async (date) => {
  try {
    const response = await api.get(`/predictions/all/games?date=${date}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all game predictions:', error);
    throw error;
  }
};

/**
 * Fetch model performance metrics
 */
export const getModelPerformance = async (sport = null, startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (sport) params.append('sport', sport);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    const response = await api.get(`/predictions/performance?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching model performance:', error);
    throw error;
  }
};

/**
 * Fetch team statistics
 */
export const getTeamStats = async (sport, teamId, season = null) => {
  try {
    const params = season ? `?season=${season}` : '';
    const response = await api.get(`/${sport}/teams/${teamId}/stats${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching team stats:', error);
    throw error;
  }
};
